/**
 * 네이버 지도 gejson 파일을 사용한 구역 그리기
 */
import axios from 'axios'

export class NaverMapGeoJsonDrawing {
    static #DEFAULT_FILL_COLOR = "#b0b0b0";
    static #DEFAULT_FILL_OPACITY = 0.5;

    constructor(map, geoJsonUrl) {
        this.map = map;
        this.geoJsonUrl = geoJsonUrl;
        this.keyPropNm = undefined;
        this.clickHandle = () => {};
        this.completedHandle = () => {};
        this.filterFun = undefined;
        this.polygonMap = {};
        this.strokeWeight = 2;
        this.strokeColor = "#ffffff";
        this.strokeOpacity = 1;
        this.strokeStyle = 'solid';
        this.fillColor = NaverMapGeoJsonDrawing.#DEFAULT_FILL_COLOR;
        this.fillOpacity = 0.5;
    }

    getMap() {
        return this.map;
    }

    setMap(map) {
        this.map = map;
        return this;
    }

    getGeoJsonUrl() {
        return this.geoJsonUrl;
    }

    setGeoJsonUrl(geoJsonUrl) {
        this.geoJsonUrl = geoJsonUrl;
        return this;
    }

    setClickHandle(clickHandle) {
        this.clickHandle = clickHandle;
        return this;
    }

    setCompletedHandle(completedHandle) {
        this.completedHandle = completedHandle;
        return this;
    }

    getkeyPropNm() {
        return this.keyPropNm;
    }

    setkeyPropNm(keyPropNm) {
        this.keyPropNm = keyPropNm;
        return this;
    }

    filter(filter) {
        this.filterFun = filter;
        return this;
    }

    setDefaultStrokeWeight(strokeWeight) {
        this.strokeWeight = strokeWeight;
        return this;
    }

    setDefaultStrokeColor(strokeColor) {
        this.strokeColor = strokeColor;
        return this;
    }

    setDefaultStrokeOpacity(strokeOpacity) {
        this.strokeOpacity = strokeOpacity;
        return this;
    }

    setDefaultStrokeStyle(StrokeStyle) {
        this.strokeStyle = strokeStyle;
        return this;
    }

    setDefaultFillColor(fillColor) {
        this.fillColor = fillColor;
        return this;
    }

    setDefaultFillOpacity(fillOpacity) {
        this.fillOpacity = fillOpacity;
        return this;
    }

    drawPolygon(paths, prop) {
        let map = this.map;

        let polygon = new naver.maps.Polygon({
            map: map,
            paths: paths,
            fillColor: this.fillColor,
            fillOpacity: this.fillOpacity,
            strokeStyle: this.strokeStyle,
            strokeWeight: this.strokeWeight,
            strokeColor: this.strokeColor,
            strokeOpacity: this.strokeOpacity,
            clickable: true
        });

        var clickListener;
        if(typeof this.clickHandle !== 'undefined') {
            clickListener = naver.maps.Event.addListener(polygon, 'click', () => {
                this.clickHandle(this, prop, event);
            });
        }

        if(typeof this.keyPropNm !== 'undefined' &&
                typeof prop[this.keyPropNm] !== 'undefined') {

            var key = "p_" + prop[this.keyPropNm];
            if(typeof this.polygonMap[key] === 'undefined') {

                this.polygonMap[key] = {
                    polygons: [],
                    clickListener: clickListener
                };
            }

            this.polygonMap["p_" + prop[this.keyPropNm]].polygons.push(polygon);
        }
    }

    drawGeoJson() {
        axios.get(this.geoJsonUrl)
            .then(res => {
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));

                let newFeatures;
                if(typeof this.filterFun !== 'undefined') {
                    newFeatures = geoJson.features.filter(this.filterFun);
                } else {
                    newFeatures = geoJson.features;
                }

                newFeatures.map((currVal, idx, arr) => {
                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach(paths => {
                        if(paths.length == 1) {
                            paths = paths[0];
                        }

                        this.drawPolygon(paths, currVal.properties);
                    });
                });

                if(typeof this.completedHandle !== 'undefined') {
                    this.completedHandle(this);
                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    clearAll() {
        for(let property in this.polygonMap) {
            let polygons = this.polygonMap[property].polygons;
            let listener = this.polygonMap[property].clickListener;

            naver.maps.Event.removeListener(listener);

            polygons.forEach(polygon => {
                polygon.setMap(null);
            });
        }

        this.polygonMap = {};
    }

    disableAll() {
        for(let property in this.polygonMap) {
            let polygons = this.polygonMap[property].polygons;

            polygons.forEach(polygon => {
                polygon.setMap(null);
            });
        }
    }

    enableAll() {
        for(let property in this.polygonMap) {
            let polygons = this.polygonMap[property].polygons;
            polygons.forEach(polygon => {
                polygon.setMap(this.map);
            });
        }
    }

    setFillColor(key, color) {
        let realKey = "p_" + key;

        if(this.polygonMap[realKey] != undefined) {
            this.polygonMap[realKey].polygons.forEach(polygon => {
                polygon.setOptions({'fillColor' : color})
            });
        }
    }

    setDefaultFillColor() {
        this.setOptionAll("fillColor", NaverMapGeoJsonDrawing.#DEFAULT_FILL_COLOR);
        this.setOptionAll("fillOpacity", NaverMapGeoJsonDrawing.#DEFAULT_FILL_OPACITY);
    }

    setOption(key, name, value) {
        var realKey = "p_" + key;

        if(this.polygonMap[realKey] != undefined) {
            let option = {};
            option[name] = value;
            this.polygonMap[realKey].polygons.forEach((polygon) => {
                polygon.setOptions(option);
            });
        }
    }

    setOptionAll(name, value) {
        let option = {};
        option[name] = value;

        for(let property in this.polygonMap) {
            let polygons = this.polygonMap[property].polygons;
            polygons.forEach(polygon => {
                polygon.setOptions(option);
            });
        }
    }

    setZIndex(key, zIndex) {
        let realKey = "p_" + key;

        if(this.polygonMap[realKey] != undefined) {
            this.polygonMap[realKey].polygons.forEach(polygon => {
                polygon.setZIndex(zIndex);
            });
        }
    }

    setZIndexAll(zIndex) {
        for(let property in this.polygonMap) {
            let polygons = this.polygonMap[property].polygons;
            polygons.forEach(polygon => {
                polygon.setZIndex(zIndex);
            });
        }
    }
}
